import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { DataCacheService } from './data-cache.service';
import { ApiRoomService } from './api-call-providers/api-room.service';
import { COOKIES_CONFIG } from '../configs/cookies.config';

export type Room = {
  roomId: string;
  integrationCode?: string;
  wardCode: string;
  wardName: string;
  unitCode: string;
  unitName: string;
  roomCode: string;
  roomName: string;
  bedNo: string;
}

export type CreateRoomInput = Pick<
  Room,
  | "integrationCode"
  | "wardCode"
  | "wardName"
  | "unitCode"
  | "unitName"
  | "roomCode"
  | "roomName"
  | "bedNo"
>;

@Injectable()
export class RoomService {

  // 部屋リスト
  private listSource = new Subject<any>();
  list$ = this.listSource.asObservable();

  // 部屋の患者リスト
  private roomPatientsSource = new Subject<any>();
  roomPatients$ = this.roomPatientsSource.asObservable();

  // 部屋登録
  private registRoomSource = new Subject<any>();
  registRoom = this.registRoomSource.asObservable();

  // 部屋登録
  private bulkRegistRoomSource = new Subject<any>();
  bulkRegistRoom = this.bulkRegistRoomSource.asObservable();

  // 部屋更新
  private updateRoomSource = new Subject<any>();
  updateRoom = this.updateRoomSource.asObservable();

  constructor(
    private apiRoomService: ApiRoomService,
    private _dataCacheService: DataCacheService,
  ) {
  }

  async load() {
    this.apiRoomService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.ROOMS_DATA)
    if (!_data.isExist()) {
      // キャッシュデータが古い or ない場合、データロード
      await this.fetch();
      return;
    }
    this.apiRoomService.isLoading = false
    this.listSource.next(_data);
    return;

  }

  get loading() {
    return this.apiRoomService.isLoading;
  }

  /**
   * APIを叩いて、部屋情報を取得する
   * @param params
   */
  async fetch() {
    let res: any = await this.apiRoomService.list();
    let data = { data: res.roomList };
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.ROOMS_DATA, res.roomList, res.expired);
    }
    this.listSource.next(data);
    return data;
  }


  async getRoomPatients() {
    let res: any = await this.apiRoomService.getRoomPatients()
    let data = { data: res.data }
    // if (res.expired) {
    //   data = await this._dataCacheService.set(COOKIES_CONFIG.ROOMS_DATA, res.roomList, res.expired)
    // }
    this.roomPatientsSource.next(data)
  }

  /**
   * お部屋情報登録
   * @param params
   */
  async regist(params) {
    await this.apiRoomService.post(params);
    await this.fetch();
    this.registRoomSource.next();
  }

  /**
   * お部屋一括登録
   */
  async bulkRegist(rooms: CreateRoomInput[]) {
    await this.apiRoomService.bulkPost(rooms);
    await this.fetch();
    this.bulkRegistRoomSource.next();
  }

  /**
   * お部屋情報更新
   * @param params
   */
  async update(params, message = null) {
    await this.apiRoomService.update(params, message)
    await this.fetch()
    this.updateRoomSource.next()
  }
}



// WEBPACK FOOTER //
// ./src/providers/room.service.ts